import React, { useEffect, useState } from "react";
import PageHeader from "../general/PageHeader";
import { Link } from "react-router-dom";
import FiltersContainer from "../general/FiltersContainer";
import Loader from "../general/Loader";
import dayjs from "dayjs";
import { formasPagoCompras, getLink, toast } from "../../utils/helpers";
import SelectAsync from "react-select/async";
import Select from "react-select";
import useFilters from "../../hooks/useFilters";
import { request } from "../../utils/request";
import Pagination from "../general/Pagination";
import CompraRow from "./CompraRow";
import { apiRequest } from "../../hooks/apiRequest";
import Modal from "../general/Modal";

const Index = () => {
    const [compras, setCompras] = useState([]);
    const [meta, setMeta] = useState();
    const [links, setLinks] = useState();
    const [loading, setLoading] = useState(false);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [compraSeleccionada, setCompraSeleccionada] = useState({});
    const { handleFilterChange, filtersQuery } = useFilters({
        hasta: dayjs().format("YYYY-MM-DD"),
    });

    const getOptions = async (url = null, label = "nombre", value = "id") => {
        const table = await request(url);
        
        if (table.data) {
            return table.data.map((item) => ({
                value: item[value],
                label: item[label],
            }));
        }

        return [];
    };

    const getCompras = async (url = null) => {
        setLoading(true);
        setCompras([]);

        url = url ? url + "&limit=20" : "compras-recurrentes?limit=20";
        const compras = await request(url);

        if (compras.data) {
            setCompras(compras.data);
            setMeta(compras.meta);
            setLinks(compras.links);
        }

        setLoading(false);
    };

    const displayFilters = () => {
        document.getElementById('mas-filtros').classList.toggle('d-none');
    }

    const setRecurrente = (recurrente) => {
        setCompras((state) => {
            return state.map((r) => r.id === recurrente.id ? recurrente : r);
        });
    };

    const toggleDeleteModal = (compra = {}) => {
		setCompraSeleccionada(compra);
		setShowDeleteModal((state) => !state);
	};

    const removeCompra = async (e, compraId) => {
        e.preventDefault();
        const response = await apiRequest(
            null,
            `compras-recurrentes/${compraId}`,
            "DELETE"
        );

        if (response.success) {
            toast("Factura recurrente eliminada");
            getCompras(`compras-recurrentes${filtersQuery}`);
            toggleDeleteModal();
            return;
        }

        toast("error eliminando Factura recurrente", "error");
    };

    const tipoMap = {
        item: "ITEMS",
        producto: "PRODUCTOS",
        suministro: "SUMINISTRO",
    };

    useEffect(() => {
        getCompras(`compras-recurrentes${filtersQuery}`);
    }, [filtersQuery]);

    return <>
        <div>
            <PageHeader title="Compras Recurrentes">
                <Link
                    to={getLink("/compras-recurrentes/crear")}
                    className="au-btn au-btn-icon au-btn--green au-btn--small"
                >
                    <i className="zmdi zmdi-plus" />
                    Nueva Compra Recurrente
                </Link>
            </PageHeader>
            <FiltersContainer>
                <div className="col">
                    <label>Buscar</label>
                    <input
                        onChange={(e) =>
                            handleFilterChange(
                                "buscar",
                                e.target.value,
                            )
                        }
                        type="search"
                        placeholder="Buscar..."
                        className="form-control"
                        name="buscar"
                    />
                </div>
                <div className="col-md-2">
                    <label htmlFor="categorias">Categorías</label>
                    <SelectAsync
                        name="categorias"
                        isMulti
                        cacheOptions
                        defaultOptions
                        isClearable
                        onChange={(e) =>
                            handleFilterChange("categorias", e)
                        }
                        loadOptions={(e) => {
                            return getOptions(
                                "taxonomias?relacion=compras&buscar=" + e
                            );
                        }}
                    />
                </div>
                <div className="col-md-2">
                    <label htmlFor="tipo">Tipo</label>
                    <Select
                        onChange={(e) =>
                            handleFilterChange("tipo", e?.value)
                        }
                        isClearable
                        options={[
                            {
                                label: "Inventario de Productos",
                                value: "producto",
                            },
                            {
                                label: "Inventario Interno",
                                value: "item",
                            },
                            {
                                label: "Trabajo/Suministro",
                                value: "suministro",
                            },
                        ]}
                    />
                </div>
                <div className="col-md-2">
                    <label htmlFor="desde">Desde</label>
                    <input
                        type="date"
                        name="desde"
                        id="desde"
                        className="form-control"
                        onChange={(e) =>
                            handleFilterChange("desde", e.target.value)
                        }
                    />
                </div>
                <div className="col-md-2">
                    <label htmlFor="hasta">Hasta</label>
                    <input
                        type="date"
                        name="hasta"
                        id="hasta"
                        defaultValue={dayjs().format("YYYY-MM-DD")}
                        className="form-control"
                        onChange={(e) =>
                            handleFilterChange("hasta", e.target.value)
                        }
                    />
                </div>
                <div style={{width: '50px'}} className="filtros-avanzados" onClick={displayFilters}>
                    <label>&nbsp;</label>
                    <button className="btn" title="Filtros Avanzados"><i className="zmdi zmdi-filter-list"></i></button>
                </div>
                <div id="mas-filtros" className="row col-md-12 mas-filtros d-none m-b-25 m-t-5">
                    <div className="col-md-3">
                        <label htmlFor="desde">Tipo Factura</label>
                        <Select
                            onChange={(e) =>
                                handleFilterChange("tipo_factura", e?.value)
                            }
                            isClearable
                            options={[
                                {
                                    label: "Todas",
                                    value: "todas",
                                },
                                {
                                    label: "Proforma",
                                    value: "proforma",
                                },
                                {
                                    label: "Comprobante Fiscal",
                                    value: "comprobante",
                                },
                            ]}
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <label className="orden-filter-label">Forma de Pago</label>
                        <Select
                            id="forma_pago"
                            options={formasPagoCompras.map(f => ({
                                label: f, value: f
                            }))}
                            name="forma_pago"
                            isMulti
                            isClearable
                            placeholder="Todas"
                            onChange={(values) =>
                                handleFilterChange("forma_pago", values)
                            }
                        />
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <label className="orden-filter-label">Estado</label>
                        <Select
                            id="estado"
                            options={[
                                {label: "Todos", value: ''},
                                {label: "Pendiente", value: 'pendiente'},
                                {label: "Pagada", value: 'pagada'},
                            ]}
                            name="estado"
                            isMulti
                            isClearable
                            placeholder="Todos"
                            onChange={(values) =>
                                handleFilterChange("estado", values)
                            }
                        />
                    </div>
                </div>
            </FiltersContainer>
            <div className="row">
                <div className="col-md-12">
                    <div>
                        {loading && <Loader />}
                        {!compras.length ? (
                            <div>
                                {!loading && (
                                    <div>
                                        Todavía no hay compras creados.
                                    </div>
                                )}
                            </div>
                        ) : (
                            <div className="table-descuentos">
                                <div className="table-descuentos__header descuento-row">
                                    <div>Suplidor</div>
                                    <div>Detalle</div>
                                    <div>Total</div>
                                    <div>Inicio</div>
                                    <div>Fechas</div>
                                    <div></div>
                                </div>

                                <div className="table-descuentos__body">
                                    {compras.map((recurrente) => (<CompraRow key={recurrente.id} recurrente={recurrente} setRecurrente={setRecurrente} toggleDeleteModal={toggleDeleteModal} />))}
                                </div>

                                {links && (
                                    <Pagination
                                        links={links}
                                        meta={meta}
                                        getData={getCompras}
                                    />
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
        
        {/* DELETE CONFIRMATION MODAL */}
        <Modal
            show={showDeleteModal}
            toggle={() => toggleDeleteModal()}
            title="Cancelar compra recurrente"
            blank={true}
        >
            <form
                onSubmit={(e) =>
                    removeCompra(e, compraSeleccionada?.id)
                }
            >
                <div className="popup__header">Eliminar Compra</div>
                <div className="popup__body">
                    <p className="m-b-20">
                        Esta acción no puede ser revertida. Si deseas
                        continuar por favor indica la razón por la cual
                        deseas eliminarla:
                    </p>
                </div>
                <div className="popup__footer">
                    <button
                        onClick={() => toggleDeleteModal()}
                        type="button"
                        className="btn btn-plain"
                    >
                        Cancelar
                    </button>
                    <button type="submit" className="btn btn-primary">
                        Eliminar
                    </button>
                </div>
            </form>
        </Modal>
    </>;
};

export default Index;